var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapAutocomplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-map",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.03 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04BE76;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M10.512,30a.588.588,0,0,1-.48-.246C9.932,29.62,0,16.225,0,10.512a10.515,10.515,0,0,1,21.03,0c0,5.6-9.623,18.688-10.032,19.242A.6.6,0,0,1,10.512,30Zm0-24.57A5.085,5.085,0,1,0,15.6,10.512,5.088,5.088,0,0,0,10.512,5.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAutocomplete);
export default __webpack_public_path__ + "static/media/map_autocomplete.f8f51311b5f74dba0c89849b219f45c2.svg";
export { ForwardRef as ReactComponent };